export default "__VITE_ASSET__D7_jd4lU__"